import styled from "styled-components";
import { ModalWithContext } from "app/components/Modal";

export const DesktopModal = styled(ModalWithContext)`
  padding: 0;
  border-radius: 10px;
  overflow: hidden;
  max-width: 768px;
`;

export const MobileModal = styled(ModalWithContext)`
  width: 100%;
  height: 100%;
  max-height: 100vh;
  max-width: 100vw;
  border-radius: 0;
  overflow: auto;
  padding: 0;
`;
